import { render } from "./Menu.vue?vue&type=template&id=463c52ee&scoped=true&bindings={}"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=463c52ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-463c52ee"

export default script